import config from '../../../../../../../../config'

import {
    ENTITY_SEARCH_REQUEST,
    ENTITY_SEARCH_START,
    ENTITY_SEARCH_END,
    SOCKET_ENTITY_SEARCH_START,
    ENTITY_STACK_SEARCH_SET_ENTITIES,
} from './constants'

export function entitySearchRequest(searchValue, sessionId) {
    return {
        type: ENTITY_SEARCH_REQUEST,
        payload: {
            ...config.api.entityStack.entitySearch,
            qs: {
                sid: sessionId,
                q: searchValue,
                s__last_row: config.components.entityStack.search.searchLimit, // eslint-disable-line camelcase
            },
            headers: {
                sid: `gnosus/${sessionId}`,
            },
        },
    }
}

export function entitySearchStart(searchValue) {
    return {
        type: ENTITY_SEARCH_START,
        data: {
            searchValue,
        },
    }
}

export function socketEntitySearchStart(searchValue) {
    return {
        type: SOCKET_ENTITY_SEARCH_START,
        data: {
            searchValue,
        },
    }
}

export function entitySearchEnd(searchValue) {
    return {
        type: ENTITY_SEARCH_END,
        data: {
            searchValue,
        },
    }
}

export function entityStackSearchSetEntities(entities) {
    return {
        type: ENTITY_STACK_SEARCH_SET_ENTITIES,
        data: {
            entities,
        },
    }
}
